import {Service} from '@s-ui/domain'

export default class GetSearchParamsRequestService extends Service {
  constructor({config, searchRequestValueObjectFactory, searchRequestJSONToSearchParamsRequestJSONMapper}) {
    super({
      config,
      searchRequestValueObjectFactory,
      searchRequestJSONToSearchParamsRequestJSONMapper
    })

    this._config = config
    this._defaultPage = 1
    this._defaultSortOrder = this._config.get('ORDER').DESC
    this._defaultSortBy = this._config.get('SORT_FIELDS').RELEVANCE
    this._searchRequestValueObjectFactory = searchRequestValueObjectFactory
    this._searchRequestJSONToSearchParamsRequestJSONMapper = searchRequestJSONToSearchParamsRequestJSONMapper
  }

  execute({
    page = this._defaultPage,
    sortBy = this._defaultSortBy,
    sortOrder = this._defaultSortOrder,
    categoryId,
    offerTypeId,
    ...filters
  } = {}) {
    // we validate if the search is correct creating an instance.
    // Validate method is executing under-the-hood
    const searchRequestObjectAdsVO = this._searchRequestValueObjectFactory({
      page,
      sortBy,
      sortOrder,
      categoryId,
      offerTypeId,
      ...filters
    })

    return this._searchRequestJSONToSearchParamsRequestJSONMapper.setParams(searchRequestObjectAdsVO.toJSON()).map()
  }
}
